/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Questions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Question from './Question/index'
import React from 'react'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import styles from './view.module.css'
import useListItemDataOnChange from './useListItemDataOnChange.js'



/** @type {import('Simple/types.js').View} */
export default function Questions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories/Category/Questions"
  
}) {
let categoryQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'questions',
})
  return (<React.Fragment
>
<TysiaCardContent
  viewPath={`${viewPath}/TysiaCardContent`}
>
{childProps => (
<div
  data-testid="Questions.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(categoryQuestionsValueData) && categoryQuestionsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="question"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Question(${item?.id ?? item?._id ?? index})`}
      >
<Question
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Question(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
)}
</TysiaCardContent>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    let onChange = useListItemDataOnChange({ ...props, viewPath: props.parentViewPath })
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      onChange={onChange}
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }